import { Text, TextProps } from '@mantine/core';
import classes from './Inputs.module.css';
import { ReactNode } from 'react';
import { useCapabilityHelpLabel } from '@/pages/Editor/components/StepSidebar/CapabilityHelpContext.tsx';

type props = TextProps & {
  children: ReactNode;
  capabilityFieldId?: string;
};

const StyledInputLabel = ({ children, capabilityFieldId, ...props }: props) => {
  const label = useCapabilityHelpLabel(children, capabilityFieldId);
  return (
    <Text {...props} classNames={{ root: classes.label }}>
      {label}
    </Text>
  );
};

export default StyledInputLabel;
